import { Action } from '@ngrx/store';
import { TransportationType } from '@signal/asp-data-commons';
import { ShopMaxPerDay, MasterSlot, ShopMaxPerTime } from '../../shared/models/slot-management.model';

export enum SalesAvailabilityActionTypes {
    LOAD_MASTER_SLOTS = '[Sales Availability Management] Load master Slots details',
    LOAD_MASTER_SLOTS_SUCCESS = '[Sales Availability Management] Load master slots details success',
    LOAD_MASTER_SLOTS_FAILURE = '[Sales Availability Management] Load master slots details failure',
    LOAD_SHOP_MAX_SLOTS = '[Sales Availability Management] Load shop max Slots details',
    LOAD_SHOP_MAX_SLOTS_SUCCESS = '[Sales Availability Management] Load shop max slots details success',
    LOAD_SHOP_MAX_SLOTS_FAILURE = '[Sales Availability Management] Load shop max slots details failure',
    LOAD_SHOP_MAX_TOTAL = '[Sales Availability Management] Load shop max total details',
    LOAD_SHOP_MAX_TOTAL_SUCCESS = '[Sales Availability Management] Load shop max total details success',
    LOAD_SHOP_MAX_TOTAL_FAILURE = '[Sales Availability Management] Load shop max total details failure',
    UPDATE_SHOP_MAX_TOTAL = '[Sales Availability Management] Update shop max total details',
    UPDATE_SHOP_MAX_TOTAL_SUCCESS = '[Sales Availability Management] Update shop max total details success',
    UPDATE_SHOP_MAX_TOTAL_FAILURE = '[Sales Availability Management] Update shop max total details failure',
    UPDATE_SHOP_MAX_SLOTS = '[Sales Availability Management] Update shop max slots details',
    UPDATE_SHOP_MAX_SLOTS_SUCCESS = '[Sales Availability Management] Update shop max slots details success',
    UPDATE_SHOP_MAX_SLOTS_FAILURE = '[Sales Availability Management] Update shop max slots details failure',
    LOAD_TRANSPORT_MAX_SLOTS = '[Sales Availability Management] Load transport max Slots details',
    LOAD_TRANSPORT_MAX_SLOTS_SUCCESS = '[Sales Availability Management] Load transport max slots details success',
    LOAD_TRANSPORT_MAX_SLOTS_FAILURE = '[Sales Availability Management] Load transport max slots details failure',
    LOAD_TRANSPORT_MAX_TOTAL = '[Sales Availability Management] Load transport max total details',
    LOAD_TRANSPORT_MAX_TOTAL_SUCCESS = '[Sales Availability Management] Load transport max total details success',
    LOAD_TRANSPORT_MAX_TOTAL_FAILURE = '[Sales Availability Management] Load transport max total details failure',
    UPDATE_TRANSPORT_MAX_TOTAL = '[Sales Availability Management] Update transport max total details',
    UPDATE_TRANSPORT_MAX_TOTAL_SUCCESS = '[Sales Availability Management] Update transport max total details success',
    UPDATE_TRANSPORT_MAX_TOTAL_FAILURE = '[Sales Availability Management] Update transport max total details failure',
    UPDATE_TRANSPORT_MAX_SLOTS = '[Sales Availability Management] Update transport max slots details',
    UPDATE_TRANSPORT_MAX_SLOTS_SUCCESS = '[Sales Availability Management] Update transport max slots details success',
    UPDATE_TRANSPORT_MAX_SLOTS_FAILURE = '[Sales Availability Management] Update transport max slots details failure',
}

export class LoadMasterSlots implements Action {
    readonly type: string = SalesAvailabilityActionTypes.LOAD_MASTER_SLOTS;

    constructor() {
    }
}

export class LoadMasterSlotsSuccess implements Action {
    readonly type = SalesAvailabilityActionTypes.LOAD_MASTER_SLOTS_SUCCESS;

    constructor(public payload: { masterSlots: MasterSlot[] }) {
    }
}

export class LoadMasterSlotsFailure implements Action {
    readonly type = SalesAvailabilityActionTypes.LOAD_MASTER_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadShopMaxSlots implements Action {
    readonly type: string = SalesAvailabilityActionTypes.LOAD_SHOP_MAX_SLOTS;

    constructor() {
    }
}

export class LoadShopMaxSlotsSuccess implements Action {
    readonly type = SalesAvailabilityActionTypes.LOAD_SHOP_MAX_SLOTS_SUCCESS;

    constructor(public payload: { shopMaxSlots: ShopMaxPerTime }) {
    }
}

export class LoadShopMaxSlotsFailure implements Action {
    readonly type = SalesAvailabilityActionTypes.LOAD_SHOP_MAX_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadShopMaxTotal implements Action {
    readonly type: string = SalesAvailabilityActionTypes.LOAD_SHOP_MAX_TOTAL;

    constructor() {
    }
}

export class LoadShopMaxTotalSuccess implements Action {
    readonly type = SalesAvailabilityActionTypes.LOAD_SHOP_MAX_TOTAL_SUCCESS;

    constructor(public payload: { shopMaxTotal: ShopMaxPerDay[] }) {
    }
}

export class LoadShopMaxTotalFailure implements Action {
    readonly type = SalesAvailabilityActionTypes.LOAD_SHOP_MAX_TOTAL_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateShopMaxTotal implements Action {
    readonly type: string = SalesAvailabilityActionTypes.UPDATE_SHOP_MAX_TOTAL;

    constructor(public payload: { shopMaxTotal: ShopMaxPerDay[] }) {
    }
}

export class UpdateShopMaxTotalSuccess implements Action {
    readonly type = SalesAvailabilityActionTypes.UPDATE_SHOP_MAX_TOTAL_SUCCESS;

    constructor(public payload: { shopMaxTotal: ShopMaxPerDay[] }) {
    }
}

export class UpdateShopMaxTotalFailure implements Action {
    readonly type = SalesAvailabilityActionTypes.UPDATE_SHOP_MAX_TOTAL_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateShopMaxSlots implements Action {
    readonly type: string = SalesAvailabilityActionTypes.UPDATE_SHOP_MAX_SLOTS

    constructor(public payload: { shopMaxSlots: ShopMaxPerTime,bothFormsEdited:boolean }) {
    }
}

export class UpdateShopMaxSlotsSuccess implements Action {
    readonly type = SalesAvailabilityActionTypes.UPDATE_SHOP_MAX_SLOTS_SUCCESS;

    constructor(public payload: { shopMaxSlots: ShopMaxPerTime }) {
    }
}

export class UpdateShopMaxSlotsFailure implements Action {
    readonly type = SalesAvailabilityActionTypes.UPDATE_SHOP_MAX_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

/* Transport Capacity */
export class LoadTransportMaxSlots implements Action {
    readonly type: string = SalesAvailabilityActionTypes.LOAD_TRANSPORT_MAX_SLOTS;

    constructor(public payload: { transport: TransportationType }) {
    }
}

export class LoadTransportMaxSlotsSuccess implements Action {
    readonly type = SalesAvailabilityActionTypes.LOAD_TRANSPORT_MAX_SLOTS_SUCCESS;

    constructor(public payload: { transport: TransportationType, transportMaxSlots: ShopMaxPerTime }) {
    }
}

export class LoadTransportMaxSlotsFailure implements Action {
    readonly type = SalesAvailabilityActionTypes.LOAD_TRANSPORT_MAX_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class LoadTransportMaxTotal implements Action {
    readonly type: string = SalesAvailabilityActionTypes.LOAD_TRANSPORT_MAX_TOTAL;

    constructor(public payload: { transport: TransportationType }) {
    }
}

export class LoadTransportMaxTotalSuccess implements Action {
    readonly type = SalesAvailabilityActionTypes.LOAD_TRANSPORT_MAX_TOTAL_SUCCESS;

    constructor(public payload: { transport: TransportationType, transportMaxTotal: ShopMaxPerDay[] }) {
    }
}

export class LoadTransportMaxTotalFailure implements Action {
    readonly type = SalesAvailabilityActionTypes.LOAD_TRANSPORT_MAX_TOTAL_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateTransportMaxTotal implements Action {
    readonly type: string = SalesAvailabilityActionTypes.UPDATE_TRANSPORT_MAX_TOTAL;

    constructor(public payload: { transport: TransportationType, transportMaxTotal: ShopMaxPerDay[] }) {
    }
}

export class UpdateTransportMaxTotalSuccess implements Action {
    readonly type = SalesAvailabilityActionTypes.UPDATE_TRANSPORT_MAX_TOTAL_SUCCESS;

    constructor(public payload: { transport: TransportationType, transportMaxTotal: ShopMaxPerDay[] }) {
    }
}

export class UpdateTransportMaxTotalFailure implements Action {
    readonly type = SalesAvailabilityActionTypes.UPDATE_TRANSPORT_MAX_TOTAL_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export class UpdateTransportMaxSlots implements Action {
    readonly type: string = SalesAvailabilityActionTypes.UPDATE_TRANSPORT_MAX_SLOTS

    constructor(public payload: { transport: TransportationType, transportMaxSlots: ShopMaxPerTime,bothFormsEdited:boolean }) {
    }
}

export class UpdateTransportMaxSlotsSuccess implements Action {
    readonly type = SalesAvailabilityActionTypes.UPDATE_TRANSPORT_MAX_SLOTS_SUCCESS;

    constructor(public payload: { transport: TransportationType, transportMaxSlots: ShopMaxPerTime }) {
    }
}

export class UpdateTransportMaxSlotsFailure implements Action {
    readonly type = SalesAvailabilityActionTypes.UPDATE_TRANSPORT_MAX_SLOTS_FAILURE;

    constructor(public payload: { error: string }) {
    }
}

export type SalesAvailabilityActions =
    LoadMasterSlots
    | LoadMasterSlotsSuccess
    | LoadMasterSlotsFailure
    | LoadShopMaxSlots
    | LoadShopMaxSlotsSuccess
    | LoadShopMaxSlotsFailure
    | LoadShopMaxTotal
    | LoadShopMaxTotalSuccess
    | LoadShopMaxTotalFailure
    | UpdateShopMaxTotal
    | UpdateShopMaxTotalSuccess
    | UpdateShopMaxTotalFailure
    | UpdateShopMaxSlots
    | UpdateShopMaxSlotsSuccess
    | UpdateShopMaxSlotsFailure
    | LoadTransportMaxSlots
    | LoadTransportMaxSlotsSuccess
    | LoadTransportMaxSlotsFailure
    | LoadTransportMaxTotal
    | LoadTransportMaxTotalSuccess
    | LoadTransportMaxTotalFailure
    | UpdateTransportMaxTotal
    | UpdateTransportMaxTotalSuccess
    | UpdateTransportMaxTotalFailure
    | UpdateTransportMaxSlots
    | UpdateTransportMaxSlotsSuccess
    | UpdateTransportMaxSlotsFailure;